import script from "./ImgCom.vue?vue&type=script&setup=true&lang=js"
export * from "./ImgCom.vue?vue&type=script&setup=true&lang=js"

import "./ImgCom.vue?vue&type=style&index=0&id=5f59a29c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f59a29c"]])

export default __exports__